import { render, staticRenderFns } from "./FooterMusicBuiz.vue?vue&type=template&id=fd7913f2&"
import script from "./FooterMusicBuiz.vue?vue&type=script&lang=js&"
export * from "./FooterMusicBuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FooterMusicBuiz.vue"
export default component.exports